import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=7a5481d9&scoped=true"
import script from "./MyPage.vue?vue&type=script&lang=js"
export * from "./MyPage.vue?vue&type=script&lang=js"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=7a5481d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5481d9",
  null
  
)

export default component.exports